import { baseFunc, nextFetch } from "./server-base";

class API {
  url = "";
  api = baseFunc("");
  next = nextFetch("");
  constructor(url: string) {
    this.url = url;
    this.api = baseFunc(url);
    this.next = nextFetch(url);
  }
}
export const Countries =  new API("countries")
export const CountryProducts =  new API("countryproducts")
export const CountryCategory =  new API("countrycategories")
export const Products =  new API("products")
export const CategoryTypes = new API("categorytypes")
export const Category = new API("categories")
export const Contact = new API("contactus");
export const Application = new API("applications");
export const Testimonial = new API("testimonials")
export const ProductReview = new API("productreviews")
export const Blogs = new API("blogs")
export const CountriesAPI = new API("countries")